import {
  appointmentRescheduleErrorI18nKey,
  classifyAppointmentRescheduleError,
  extractRpcErrorMessage,
} from '@/utils/appointmentRescheduleError';

function errorCode(err: unknown): string {
  if (!err || typeof err !== 'object' || !('code' in err)) return '';
  const code = (err as { code: unknown }).code;
  return typeof code === 'string' ? code : '';
}

/**
 * Ny aftale used `err instanceof Error`, so a PostgREST error object
 * (`{ message, code }`, not an Error) became "unknown" and the toast was
 * "Der opstod en uventet fejl." The database text is either
 * `conflict: clinician already has an appointment…` or the raw exclusion
 * message `conflicting key value violates exclusion constraint …` (23P01).
 */
export function isPractitionerTimeConflict(err: unknown): boolean {
  const message = (extractRpcErrorMessage(err) ?? '').toLowerCase();
  const code = errorCode(err);
  if (code === '23P01') return true;
  if (message.includes('conflict: selected resource')) return false;
  if (message.includes('conflict: required resource')) return false;
  if (message.includes('conflict: time overlaps a calendar block')) return false;
  if (message.includes('conflict:')) return true;
  if (message.includes('conflicting key')) return true;
  if (message.includes('exclusion constraint')) return true;
  return false;
}

export function appointmentSaveErrorI18nKey(err: unknown, editing: boolean): string {
  const message = (extractRpcErrorMessage(err) ?? '').toLowerCase();
  if (message.includes('not eligible')) return 'appointments.errors.practitioner_ineligible';
  if (message.includes('not compatible')) return 'appointments.errors.resource_incompatible';
  if (message.includes('conflict: selected resource is not available')) {
    return 'appointments.errors.resource_selected_unavailable';
  }
  if (message.includes('conflict: required resource is not available')) {
    return 'appointments.errors.resource_required_unavailable';
  }
  if (message.includes('conflict: time overlaps a calendar block')) {
    return 'appointments.errors.conflict';
  }
  if (isPractitionerTimeConflict(err)) {
    return editing ? 'appointments.errors.reschedule_unavailable' : 'appointments.errors.conflict';
  }
  if (editing) return appointmentRescheduleErrorI18nKey(classifyAppointmentRescheduleError(err));
  return 'appointments.errors.unknown';
}
